/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,

      isTerminationOFFProblemChecked: false,
      isNoPowerSupplyTerminationProblemChecked: false,
      isHighResistanceProblemChecked: false,
      isANotOkProblemChecked: false,
      isBNotOkProblemChecked: false,
      isLongCableProblemChecked: false,
      isNoiseProblemChecked: false,
      isReflectionProblemChecked: false,
      isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
      isFiberSignalLostProblemChecked: false,
    };
  }

  retrieveData = () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isTerminationOFFProblemChecked: data.isTerminationOFFProblemChecked,
        isNoPowerSupplyTerminationProblemChecked: data.isNoPowerSupplyTerminationProblemChecked,
        isHighResistanceProblemChecked: data.isHighResistanceProblemChecked,
        isANotOkProblemChecked: data.isANotOkProblemChecked,
        isBNotOkProblemChecked: data.isBNotOkProblemChecked,
        isLongCableProblemChecked: data.isLongCableProblemChecked,
        isNoiseProblemChecked: data.isNoiseProblemChecked,
        isReflectionProblemChecked: data.isReflectionProblemChecked,
      }));
    
    if (isFiberProcessOn) {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpertConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({
          isFiberLowerLimitMaintenanceRequiredProblemChecked: data.isFiberLowerLimitMaintenanceRequiredProblemChecked,
          isFiberLowerLimitUrgentMaintenanceProblemChecked: data.isFiberLowerLimitUrgentMaintenanceProblemChecked,
          isFiberSignalLostProblemChecked: data.isFiberSignalLostProblemChecked,
        }));
    } else {
      this.setState({
        isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
        isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
        isFiberSignalLostProblemChecked: false,
      });
    }
  }

  // ------ Toggle Checkboxes ---------
  toggleIsOffPositionTermProblemCheckbox = () => {
    this.setState({ isTerminationOFFProblemChecked: !this.state.isTerminationOFFProblemChecked });
  }

  toggleIsTermWithoutPowerSupplyProblemCheckbox = () => {
    this.setState({ isNoPowerSupplyTerminationProblemChecked: !this.state.isNoPowerSupplyTerminationProblemChecked });
  }

  toggleIsMoreThan2TermProblemCheckbox = () => {
    this.setState({ isHighResistanceProblemChecked: !this.state.isHighResistanceProblemChecked });
  }

  toggleIsShortCircuitAProblemCheckbox = () => {
    this.setState({ isANotOkProblemChecked: !this.state.isANotOkProblemChecked });
  }

  toggleIsShortCircuitBProblemCheckbox = () => {
    this.setState({ isBNotOkProblemChecked: !this.state.isBNotOkProblemChecked });
  }

  toggleIsLongCableProblemCheckbox = () => {
    this.setState({ isLongCableProblemChecked: !this.state.isLongCableProblemChecked });
  }

  toggleIsNoiseProblemCheckbox = () => {
    this.setState({ isNoiseProblemChecked: !this.state.isNoiseProblemChecked });
  }

  toggleIsReflectionProblemCheckbox = () => {
    this.setState({ isReflectionProblemChecked: !this.state.isReflectionProblemChecked });
  }

  toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitMaintenanceRequiredProblemChecked: !this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked });
  }

  toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitUrgentMaintenanceProblemChecked: !this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked });
  }

  toggleIsFiberSignalLostProblemCheckbox = () => {
    this.setState({ isFiberSignalLostProblemChecked: !this.state.isFiberSignalLostProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = async () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";
    this.showSendingConfigDimmer();

    const data = {
      isTerminationOFFProblemChecked: this.state.isTerminationOFFProblemChecked,
      isNoPowerSupplyTerminationProblemChecked: this.state.isNoPowerSupplyTerminationProblemChecked,
      isHighResistanceProblemChecked: this.state.isHighResistanceProblemChecked,
      isANotOkProblemChecked: this.state.isANotOkProblemChecked,
      isBNotOkProblemChecked: this.state.isBNotOkProblemChecked,
      isLongCableProblemChecked: this.state.isLongCableProblemChecked,
      isNoiseProblemChecked: this.state.isNoiseProblemChecked,
      isReflectionProblemChecked: this.state.isReflectionProblemChecked,
    };

    const dataOpticFiber = {
      isFiberLowerLimitMaintenanceRequiredProblemChecked: this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked,
      isFiberSignalLostProblemChecked: this.state.isFiberSignalLostProblemChecked,
    };

    try {
      await fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(data)
      }).then(UtilsInstance.checkStatus);
      
      if (isFiberProcessOn) {
        await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/tsExpertConfig_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: JSON.stringify(dataOpticFiber)
        }).then(UtilsInstance.checkStatus);
      }

      alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
    } catch (error) {
      alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
    } finally {
      this.hideSendingConfigDimmer();
    }
  }

  opticFiberEvents = () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      return (
        <>
          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}</List.Header>
                {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox}
                  checked={this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>

          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}</List.Header>
                {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox}
                  checked={this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>

          <List.Item>
            <Grid columns={2}>
              <Grid.Column width={14}>
                <List.Header>{Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}</List.Header>
                {Strings.FIBER_SIGNAL_LOSS_LIST_CONTENT}
              </Grid.Column>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                <Checkbox
                  toggle
                  onChange={this.toggleIsFiberSignalLostProblemCheckbox}
                  checked={this.state.isFiberSignalLostProblemChecked} />
              </Grid.Column>
            </Grid>
          </List.Item>
        </>
      );
    } else {
      return;
    }
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Container text>

        <Segment>
          <Header as='h2' textAlign="center" color="teal">
            {Strings.TS_EXPERT_CONFIGURATION}
          </Header>
          <Divider clearing />

          <Segment id="problems-list" style={listSegmentStyle} basic>

            <List divided verticalAlign='middle'>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.TERMINATION_OFF_LIST_HEADER}</List.Header>
                      {Strings.TERMINATION_OFF_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsOffPositionTermProblemCheckbox}
                        checked={this.state.isTerminationOFFProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.NO_POWER_SUPPLY_LIST_HEADER}</List.Header>
                      {Strings.NO_POWER_SUPPLY_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsTermWithoutPowerSupplyProblemCheckbox}
                        checked={this.state.isNoPowerSupplyTerminationProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.HIGH_RESISTANCE_LIST_HEADER}</List.Header>
                      {Strings.HIGH_RESISTANCE_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsMoreThan2TermProblemCheckbox}
                        checked={this.state.isHighResistanceProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.A_NOT_OK_LIST_HEADER}</List.Header>
                      {Strings.A_NOT_OK_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsShortCircuitAProblemCheckbox}
                        checked={this.state.isANotOkProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.B_NOT_OK_LIST_HEADER}</List.Header>
                    {Strings.B_NOT_OK_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsShortCircuitBProblemCheckbox}
                      checked={this.state.isBNotOkProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.LONG_CABLE_LIST_HEADER}</List.Header>
                    {Strings.LONG_CABLE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsLongCableProblemCheckbox}
                      checked={this.state.isLongCableProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.NOISE_LIST_HEADER}</List.Header>
                    {Strings.NOISE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsNoiseProblemCheckbox}
                      checked={this.state.isNoiseProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.REFLECTION_LIST_HEADER}</List.Header>
                    {Strings.REFLECTION_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsReflectionProblemCheckbox}
                      checked={this.state.isReflectionProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              {this.opticFiberEvents()}

            </List>

          </Segment>

          <Button
            fluid
            color="teal"
            content={Strings.SAVE}
            onClick={this.saveTsExpertConfiguration} />

          <Dimmer active={this.state.isSendingConfigDimmerActive} >
            <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
          </Dimmer>

        </Segment>

      </Container>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "54vh"
};

export default TsExpertConfig;
